module.exports = __webpack_public_path__ + "img/leaves-8184621_1280_thumb.3e6f70d0.png";